var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostEffectiveness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "loss_1_",
    "data-name": "loss (1)",
    transform: "translate(297.461 2078.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M21.078,10.539A10.539,10.539,0,1,0,7.665,20.68v4.359H4.79a.958.958,0,0,0-.677,1.635l5.749,5.749a.958.958,0,0,0,1.355,0l5.749-5.749a.958.958,0,0,0-.677-1.635H13.413V20.68A10.558,10.558,0,0,0,21.078,10.539Zm-19.162,0a8.623,8.623,0,1,1,8.623,8.623A8.633,8.633,0,0,1,1.916,10.539ZM12.455,26.954h1.519L10.539,30.39,7.1,26.954H8.623A.958.958,0,0,0,9.581,26V21.034c.316.028.635.044.958.044s.642-.015.958-.044V26A.958.958,0,0,0,12.455,26.954Zm0,0",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M123.982,72.455v-1.4a2.874,2.874,0,0,0-.948-5.587.958.958,0,1,1,.958-.958.958.958,0,1,0,1.916,0,2.879,2.879,0,0,0-1.926-2.713v-.839a.958.958,0,0,0-1.916,0V61.8a2.874,2.874,0,0,0,.968,5.58.958.958,0,1,1-.958.958.958.958,0,0,0-1.916,0,2.879,2.879,0,0,0,1.906,2.706v1.407a.958.958,0,1,0,1.916,0Zm0,0",
    transform: "translate(-112.485 -56.168)",
    fill: "#4A4A4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffectiveness);
export default __webpack_public_path__ + "static/media/cost-effectiveness.c964af5f538355125a7264afd131fae3.svg";
export { ForwardRef as ReactComponent };